@let vm =
    {
        isRentalCarRequested: isRentalCarRequested$ | async,
    };

<div id="carRentalTab" class="tab flex flex-col gap-medpace">
    @if (!isRentalCarAvailable()) {
        <medpace-alert [appearance]="'highlight'" [content]="nonAvailableMessage" />
    }
    @if (isRentalCarAvailable() || vm.isRentalCarRequested) {
        <medpace-needs-travel-radio-group
            [label]="'Will the patient need a rental car?'"
            [isDisabled]="false"
            [isUpdate]="isUpdate()"
            [formCtrl]="formGroup().controls.needsTravel"
        />
        @if (formGroup().controls.needsTravel.value) {
            <div>
                <mds-divider />
                <mds-expansion-panel
                    class="expansion-panel-request !border-y-0"
                    [panelTitle]="'Rental Car Preferences'"
                    [description]="'(from Patient Profile)'"
                >
                    <medpace-car-rental-preferences
                        [formGroup]="formGroup().controls.travel.controls.preferences"
                        [mode]="'view'"
                    />
                </mds-expansion-panel>
                <mds-divider />
            </div>
            @if (mode() === 'edit') {
                <medpace-car-rental-request-details-edit
                    [formGroup]="formGroup().controls.travel.controls.requestDetails"
                />
            } @else if (mode() === 'view') {
                <medpace-car-rental-request-details-view
                    [formValue]="formGroup().controls.travel.controls.requestDetails.getRawValue()"
                />
            }
        }
    }
</div>
